"use strict";

var _classCallCheck = require("/home/runner/work/prodigies-brochure/prodigies-brochure/node_modules/.pnpm/@babel+runtime@7.19.0/node_modules/@babel/runtime/helpers/classCallCheck");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ErrorService = exports.SeverityLevel = void 0;
/** The severity level of an error */

var SeverityLevel;

(function (SeverityLevel) {
  SeverityLevel[SeverityLevel["Debug"] = 0] = "Debug";
  SeverityLevel[SeverityLevel["Warning"] = 1] = "Warning";
  SeverityLevel[SeverityLevel["Error"] = 2] = "Error";
})(SeverityLevel = exports.SeverityLevel || (exports.SeverityLevel = {}));
/**
 * A service for managing error reporting.
 *
 * @remarks
 * Usually a feature like the Sentry feature uses this to consume errors. You can use this
 * service to report errors from your feature, and to report when the current user is changing.
 *
 * You may also use it to leave breadcrumbs, which are little bits of information that make their
 * way to the error reporting service you're using whenever an error occurs.
 */


var ErrorService = function ErrorService() {
  _classCallCheck(this, ErrorService);
};

exports.ErrorService = ErrorService;